import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import BrandPartners from "@/components/site/BrandPartners";
import Services from "@/components/site/Services";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="relative bg-[#FAFAF8] text-[#1E293B]" data-testid="landing-root">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <BrandPartners />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}